export enum HowDiscoverUsTypeEnum {
  site = 'SITE',
  linkedin = 'LINKEDIN',
  google = 'GOOGLE_SEARCH',
  indication = 'INDICATION',
  trust = 'TRUST_CONTACT_TEAM',
}
